import BlackoutDates from "pages/blackout-dates";

const routes = [
  {
    path: `/blackout-dates`,
    exact: true,
    auth: true,
    component: BlackoutDates,
  },
  // // coupon detail
  // {
  //   path: `/coupons/:couponId`,
  //   exact: true,
  //   auth: true,
  //   component: CouponDetail,
  // },
  // // create coupon code
  // {
  //   path: `/coupon/create`,
  //   exact: true,
  //   auth: true,
  //   component: CouponDetail,
  // },
];

export default routes;
